const serviceModules = {
  ProvideMyself: 'provide-myself',
  Grubhub: 'grubhub',
  MealGiftCard: 'meal-gift-card',
  GenericGiftCard: 'generic-gift-card',
};

export const isGiftCardServiceModule = (serviceModule: string) => serviceModule && serviceModule.endsWith('-gift-card');

export default serviceModules;
